import { useContext } from 'react';

import { SentinelTeamContext } from 'contexts/SentinelTeamContext';

export default function useSentinelTeam() {
  return useContext(SentinelTeamContext) ?? {};
}
